var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButton330Disabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 91,
    viewBox: "0 0 330 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_bow_button_330",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 317,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6991 14.3849C61.5116 16.4186 264.785 14.7547 287.261 13.2757C305.523 12.1664 311.923 13.6454 315.825 32.1331C318.01 42.4861 316.761 66.1503 315.201 73.9151C313.327 82.6043 307.552 90.554 291.163 90.1842C276.335 89.8145 67.9111 89.6296 29.3578 90.9238C3.13527 92.033 2.8231 80.7556 1.41832 74.2849C0.0135413 67.8142 -0.766891 41.5618 1.10615 33.9818C5.94482 15.8639 21.2413 13.6454 31.6991 14.3849Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_bow_button_330)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6991 14.3849C61.5116 16.4186 264.785 14.7547 287.261 13.2757C305.523 12.1664 311.923 13.6454 315.825 32.1331C318.01 42.4861 316.761 66.1503 315.201 73.9151C313.327 82.6043 307.552 90.554 291.163 90.1842C276.335 89.8145 67.9111 89.6296 29.3578 90.9238C3.13527 92.033 2.8231 80.7556 1.41832 74.2849C0.0135413 67.8142 -0.766891 41.5618 1.10615 33.9818C5.94482 15.8639 21.2413 13.6454 31.6991 14.3849Z",
    fill: "url(#paint0_linear_bow_button_330)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89582 74.494C-1.00144 57.5 -0.50107 40 2.23666 31L17.8501 14.3773C31.6709 14.4027 46.5699 14.3999 62.0074 14.3732L1.89582 74.494Z",
    fill: "url(#paint1_linear_bow_button_330)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3402 91.167C47.9267 91.2044 32.9933 91.2519 19.0429 91.311L96.0649 14.2798C110.869 14.2251 125.803 14.1525 140.432 14.0655L63.3402 91.167Z",
    fill: "url(#paint2_linear_bow_button_330)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.566 91.0589C127.004 91.0657 112.137 91.0795 97.3699 91.1013L174.63 13.8318C190.559 13.708 205.633 13.569 219.195 13.42L141.566 91.0589Z",
    fill: "url(#paint3_linear_bow_button_330)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.653 91.0891C206.162 91.071 191.256 91.0591 175.533 91.0552L253.613 12.9658C267.299 12.743 277.004 12.5111 281.07 12.2835C288.14 11.9181 293.739 11.8259 298.238 12.4947L219.653 91.0891Z",
    fill: "url(#paint4_linear_bow_button_330)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.846 90.0134C295.274 90.9464 290.969 91.4331 285.785 91.3336C282.587 91.2658 270.884 91.204 253.55 91.1558L315.049 29.6493C315.23 30.2986 315.407 30.9706 315.579 31.666C318.142 41.9949 316.796 65.2138 314.99 73.8669L298.846 90.0134Z",
    fill: "url(#paint5_linear_bow_button_330)",
    fillOpacity: 0.5
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117 18.5953C117 15.2816 119.686 12.5953 123 12.5953H311C314.314 12.5953 317 15.2816 317 18.5953V84.5953C317 87.909 314.314 90.5953 311 90.5953H123C119.686 90.5953 117 87.909 117 84.5953V18.5953Z",
    fill: "url(#paint6_linear_bow_button_330)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5212 24.532C11.1722 26.5301 10.8823 30.3447 11.0273 31.6162C11.1722 32.8877 13.6367 33.0694 17.1159 32.3428C20.5951 31.6162 22.9145 29.9814 22.1897 27.2567C21.3199 23.2605 18.1306 23.4421 15.5212 24.532ZM25.089 27.9833C25.8139 21.444 28.8582 21.0807 41.1803 23.0788C55.3871 25.4402 60.6059 25.2586 60.7508 26.5301C61.0408 28.7099 53.2126 28.8915 43.6448 28.8915C34.077 28.8915 24.7991 30.3447 25.089 27.9833Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bow_button_330",
    x1: 159.999,
    y1: 12.9999,
    x2: 160.034,
    y2: 90.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACC7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bow_button_330",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bow_button_330",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bow_button_330",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bow_button_330",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_bow_button_330",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_bow_button_330",
    x1: 307.199,
    y1: 7.88846,
    x2: 206.77,
    y2: 75.4646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C7895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7895",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton330Disabled);
export default __webpack_public_path__ + "static/media/button-330-disabled.68df3891.svg";
export { ForwardRef as ReactComponent };